import { createStyles } from '../../../../../../../../../styles/helpers'
import { black, textGrey } from '../../../../../../../../../styles/const/colors'

export default createStyles({
  fieldLabel: {
    fontSize: '12px',
    marginTop: '6px',
    marginRight: '6px'
  },
  customTextField: {
    height: '30px',
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  customTextSpoiler: {
    marginTop: '6px'
  },
  spoilerTitle: {
    paddingBottom: '4px',
    fontSize: '12px',
    fontWeight: '400',
    textDecoration: 'underline',
    color: textGrey,
    '&:hover': {
      color: black
    }
  },
  spoilerOpenedTitle: {
    textDecoration: 'none'
  }
})
